function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpotifyLogoGreen = function SvgSpotifyLogoGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 558.44 167.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.75,0A83.75,83.75,0,1,0,167.5,83.75h0A83.74,83.74,0,0,0,83.76,0Zm38.41,120.79a5.22,5.22,0,0,1-7.18,1.73h0c-19.66-12-44.42-14.73-73.57-8.07a5.22,5.22,0,0,1-2.32-10.17c31.9-7.3,59.26-4.16,81.34,9.33A5.23,5.23,0,0,1,122.16,120.79ZM132.41,98a6.52,6.52,0,0,1-9,2.16h0C100.92,86.3,66.6,82.29,40,90.38a6.53,6.53,0,0,1-3.8-12.5h0c30.39-9.23,68.2-4.76,94,11.12a6.52,6.52,0,0,1,2.16,9Zm.88-23.74c-27-16-71.52-17.5-97.29-9.68a7.84,7.84,0,0,1-4.55-15h0c29.58-9,78.76-7.25,109.84,11.2a7.83,7.83,0,1,1-8,13.47Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,77.31c-14.46-3.45-17-5.87-17-11,0-4.81,4.53-8,11.25-8,6.52,0,13,2.46,19.77,7.51a.94.94,0,0,0,.71.17.92.92,0,0,0,.63-.38l7.06-10a1,1,0,0,0-.18-1.29,42.72,42.72,0,0,0-27.77-9.62c-15.62,0-26.52,9.37-26.52,22.77,0,14.38,9.41,19.47,25.66,23.4,13.84,3.18,16.17,5.85,16.17,10.63,0,5.28-4.72,8.57-12.32,8.57-8.44,0-15.32-2.84-23-9.51a1.05,1.05,0,0,0-.7-.23,1,1,0,0,0-.65.34l-8,9.48a.94.94,0,0,0,.09,1.31A47.19,47.19,0,0,0,225,123.69c16.83,0,27.7-9.2,27.7-23.42C252.65,88.24,245.46,81.59,227.85,77.31Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,63.05c-7.29,0-13.28,2.87-18.21,8.76V65.18a1,1,0,0,0-.94-1H258.61a1,1,0,0,0-1,1v73.6a1,1,0,0,0,1,.95h12.95a.94.94,0,0,0,.94-.94h0V115.55a23.27,23.27,0,0,0,18.21,8.24c13.55,0,27.26-10.43,27.26-30.37S304.26,63.05,290.71,63.05Zm12.21,30.37c0,10.16-6.25,17.24-15.21,17.24s-15.53-7.41-15.53-17.24,6.68-17.23,15.53-17.23S302.92,83.43,302.92,93.42Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.13,63.05C335.68,63.05,322,76.49,322,93.64c0,17,13.58,30.27,30.91,30.27,17.51,0,31.22-13.4,31.22-30.49S370.52,63.05,353.13,63.05Zm0,47.72c-9.28,0-16.28-7.46-16.28-17.35s6.76-17.13,16.07-17.13,16.38,7.46,16.38,17.35S362.5,110.77,353.13,110.77Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.4,64.23H407.15V49.67a1,1,0,0,0-.88-1h-13a1,1,0,0,0-.95,1V64.23h-6.22a1,1,0,0,0-.94,1V76.31a1,1,0,0,0,.94,1h6.22V106.1c0,11.63,5.8,17.53,17.22,17.53a23.69,23.69,0,0,0,12.13-3,1,1,0,0,0,.47-.83V109.15a1,1,0,0,0-.95-1,1,1,0,0,0-.42.1,16.36,16.36,0,0,1-7.6,1.83c-4.15,0-6-1.88-6-6.11V77.26h14.25a1,1,0,0,0,.95-1V65.18A1,1,0,0,0,421.4,64.23Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,64.29V62.5c0-5.26,2-7.61,6.54-7.61a21.94,21.94,0,0,1,7.3,1.35,1,1,0,0,0,.85-.13,1,1,0,0,0,.39-.77V44.43a1,1,0,0,0-.67-.91A35.16,35.16,0,0,0,474.69,42c-12,0-18.28,6.73-18.28,19.47v2.74h-6.22a1,1,0,0,0-.95,1V76.31a1,1,0,0,0,.95,1h6.22v44.41a1,1,0,0,0,1,1h12.94a1,1,0,0,0,.95-1V77.26h12.09l18.52,44.4c-2.1,4.66-4.17,5.59-7,5.59a14.82,14.82,0,0,1-7.14-2,1.06,1.06,0,0,0-.76-.07,1,1,0,0,0-.56.51l-4.44,9.6a.94.94,0,0,0,.4,1.23,27.23,27.23,0,0,0,13.83,3.54c9.56,0,14.84-4.46,19.5-16.44l22.46-58a.92.92,0,0,0-.1-.88,1,1,0,0,0-.78-.41H523.87a1,1,0,0,0-.9.64L509.16,104.4,494,64.9a.94.94,0,0,0-.88-.61Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.37,
    y: 64.23,
    width: 14.84,
    height: 58.38,
    rx: 0.95,
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.86,38.51a9.29,9.29,0,1,0,9.28,9.3h0A9.31,9.31,0,0,0,435.86,38.51Z",
    style: {
      fill: "#00f387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.28,82.39a9.14,9.14,0,1,1,9.16-9.16A9.14,9.14,0,0,1,549.28,82.39Zm0-17.36a8.23,8.23,0,1,0,8.16,8.3v-.1A8.13,8.13,0,0,0,549.39,65h-.07Zm2,9.14,2.58,3.61h-2.17l-2.32-3.31h-2v3.31h-1.81V68.21h4.26c2.22,0,3.68,1.14,3.68,3.05a2.85,2.85,0,0,1-2.16,2.91Zm-1.53-4.32h-2.38v3h2.38c1.18,0,1.89-.58,1.89-1.52s-.63-1.48-1.83-1.48Z",
    style: {
      fill: "#00f387"
    }
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpotifyLogoGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spotify-logo-green.eae11327.svg";
export { ForwardRef as ReactComponent };